import { Link } from "react-router-dom";
import { MapPin, BadgeCheck } from "lucide-react";
import { fmtCount, fmtLocation } from "@/lib/api";
import { BookDmButton } from "@/components/BookDmDialog";
import { IgEmbed } from "@/components/IgEmbed";
import { Avatar } from "@/components/Avatar";

export const TechCard = ({ tech, i = 0 }) => (
  <Link to={`/tech/${tech.username}`} data-testid="nail-tech-profile-card" style={{ animationDelay: `${i * 60}ms` }}
    className="rise group block overflow-hidden rounded-2xl border border-[#EAE4DC] bg-white transition-shadow duration-300 hover:shadow-xl hover:shadow-stone-900/5">
    <IgEmbed username={tech.username} />
    <div className="p-6">
      <div className="flex items-center gap-3">
        <div className="ig-ring shrink-0"><div className="rounded-full border-2 border-white"><Avatar user={tech} className="h-11 w-11" textClass="text-base" /></div></div>
        <div className="min-w-0">
          <p className="flex items-center gap-1 truncate font-medium">{tech.name || tech.username} <BadgeCheck className="h-4 w-4 shrink-0 text-pink-500" /></p>
          <p className="truncate font-mono text-xs text-stone-500">@{tech.username}{tech.followers_count ? ` · ${fmtCount(tech.followers_count)} followers` : ""}</p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-3 text-sm text-stone-600">
        {fmtLocation(tech) && <span data-testid="tech-card-location" className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{fmtLocation(tech)}</span>}
        {tech.price_tier && <span className="font-mono text-xs">{tech.price_tier}</span>}
      </div>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {tech.specialties?.map((s) => <span key={s} className="rounded-full bg-stone-100 px-2.5 py-1 text-xs text-stone-700">{s}</span>)}
      </div>
      <div className="mt-5"><BookDmButton tech={tech} size="sm" /></div>
    </div>
  </Link>
);
